module.exports = __webpack_public_path__ + "images/bcedbba312d271b2cec25ee2e3c30411.gif";